const titleCase = function(str) {
  return str.replace(/\w\S*/g, function(txt){
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

const state = () => ({
  licensedContractors: {},
  licenseTypes: null,
  licenseStatuses: null,
  contractorViolations: null,
  violationPage: null,
});

const mutations = {
  setlicensedContractors(state, data) {
    if (data) {
      state.licensedContractors = data;
    } else {
      state.licensedContractors = null;
    }
  },
  setLicenseTypes(state, data) {
    if (data) {
      let typeArray = [];
      data.forEach(a => typeArray.push(titleCase(a['licensetype'])))
      state.licenseTypes = typeArray;
    } else {
      state.licenseTypes = null;
    }
  },
  setLicenseStatuses(state, data) {
    if (data) {
      let typeArray = [];
      data.forEach(a => typeArray.push(titleCase(a['licensestatus'])))
      state.licenseStatuses = typeArray;
    } else {
      state.licenseStatuses = null;
    }
  },
  setContractorViolations(state, data) {
    console.log('contractorLookup.js setContractorViolations is running, data:', data);
    return state.contractorViolations = data;
  },
  openViolationPage(state, data) {
    console.log('contractorLookup.js openViolationPage is running, data:', data);
    return state.violationPage = data;
  },
  closeViolationPage(state) {
    // console.log("close violation page")
    return state.violationPage = null;
  }
};

// const actions = {
//   async getContractorViolations( { commit, dispatch }) {
//     dispatch
//     try {
//       let response = await axios.get('https://phl.carto.com/api/v2/sql?q=select+*+from%20contractor_violations');
//       console.log('getContractorViolations axios call response:', response);
//       commit('setContractorViolations', response.data.rows );
//       return response
//     } catch (err) {
//       throw new Error(err)
//     }
//   },
// };

export default {
    namespaced: true,
    state,
    mutations,
    // actions,
  };